function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,392.000000) scale(0.100000,-0.100000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M408 3552 l-348 -347 0 -1553 0 -1553 25 -24 24 -25 1360 0 c839 0 1369 4 1385 10 17 6 28 21 36 47 8 27 10 569 8 1896 l-3 1859 -24 19 c-23 18 -54 19 -1069 19 l-1047 0 -347 -348z m2344 191 c2 -10 2 -813 0 -1786 l-4 -1767 -1272 2 -1271 3 0 1455 0 1455 308 5 c291 5 309 6 323 24 11 16 14 76 14 316 0 163 3 300 7 303 3 4 430 7 949 7 889 0 942 -1 946 -17z m-2037 -135 c3 -18 5 -105 3 -193 l-3 -160 -192 -3 c-179 -2 -193 -1 -193 15 0 19 350 373 368 373 6 0 14 -15 17 -32z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M490 2583 c-25 -32 -20 -69 12 -95 19 -17 80 -18 970 -18 696 0 955 3 971 11 30 16 37 28 37 66 0 67 59 63 -1006 63 l-963 0 -21 -27z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504 2092 c-21 -13 -34 -52 -28 -77 14 -58 -35 -55 997 -55 695 0 954 3 970 11 30 16 37 28 37 66 0 67 59 63 -1005 63 -528 0 -965 -4 -971 -8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M496 1575 c-36 -36 -26 -98 19 -115 40 -15 1900 -13 1928 1 30 16 37 28 37 65 0 68 68 64 -1003 64 -847 0 -967 -2 -981 -15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504 1072 c-21 -13 -34 -52 -28 -77 14 -57 -20 -55 1007 -55 940 0 944 0 971 21 32 25 36 77 8 102 -17 16 -99 17 -983 17 -530 0 -969 -4 -975 -8z"
}));

var SvgRuc = function SvgRuc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "392.000000pt",
    viewBox: "0 0 295.000000 392.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRuc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ruc.5876c864.svg";
export { ForwardRef as ReactComponent };